<template>
  <p
    v-if="message"
    :data-test="dataTest"
    class="tw-mt-1 tw-flex tw-items-center tw-gap-1 tw-text-[13px] tw-text-orange-700"
  >
    <WdsIcon name="warning" :size="16" class="tw-text-orange-700" />
    {{ message }}
  </p>
</template>

<script setup lang="ts">
import { WdsIcon } from '@worksome/wds-components'

defineProps<{
  message?: string
  dataTest: string
}>()
</script>
